import { loadConfig } from "./scrpits/utils";
import { getHistData, getSimulatedRates, getQuantile, getMean } from "./scrpits/calcHelper";
import { Input } from "@ui5/webcomponents-react";

async function startCalcXPercent(input) {

  // Load Constants from config file
   //------------------------------
  const constants = await loadConfig();
   //------------------------------

  let inflationrate = constants.inflationrate; 
  if (input.adjustInflation){
    inflationrate = input.inflationrate;
  }
  // Get the period lengths
  //------------------------------
  let remainer = input.years % input.periodLength;

  let periodLengths = Array(Math.floor(input.years / input.periodLength)).fill(
    input.periodLength
  );

  if (remainer !== 0) periodLengths.push(remainer);

  let years = [...Array(input.years).keys()];

  let periods = [];
  let shift = 0;
  periodLengths.forEach((p, i) => {
    periods.push(years.slice(shift, shift + p));
    shift += p;
  });
  //---------------------------------------------

  // Simulate period Rates for all TrailRuns
  //----------------------------------
  let simulatedRates = await getSimulatedRates(periods,constants.simulationRuns);
  //---------------------------------

  let resultRates = simulatedRates.resultRates;

  let simulationResults = resultRates.map((x) =>
    x.map((y, i) => ({
      riskRate: y,
      risklessRate: (1 + constants.risklessRate) ** periods[i].length - 1,
      periodLength: periods[i].length,
      periodWithdrawal: periods[i].reduce(
        (p, c) =>
          p +
          input.withdrawalRate *
            input.savings *
            (1 + inflationrate) ** c,
        0
      ),
    }))
  );

  simulationResults = simulationResults.map(
    (simulationResultsLine, simulationRun) => {
      let prevPeriodSavings = input.savings;
      let prevRiskSavings = input.savings * input.riskPortionRate;
      let prevRisklessSavings = input.savings * (1 - input.riskPortionRate);

      let endPeriodSavings = 0;
      let endPeriodRiskSavings = 0;
      let endPeriodRisklessSavings = 0;

      let riskYield = 0;
      let risklessYield = 0;
      let totalYield = 0;

      let withdrawal = 0;

      let broke = false;

      simulationResultsLine.forEach((simulation, period) => {
        withdrawal = simulation.periodWithdrawal;

        broke = withdrawal > prevPeriodSavings;

        if (!broke) {
          endPeriodRiskSavings = Math.max(
            0,
            (prevPeriodSavings - withdrawal) *
              input.riskPortionRate *
              (1 + simulation.riskRate)
          );

          endPeriodRisklessSavings = Math.max(
            0,
            (prevPeriodSavings - withdrawal) *
              (1 - input.riskPortionRate) *
              (1 + simulation.risklessRate)
          );

          endPeriodSavings = endPeriodRiskSavings + endPeriodRisklessSavings;
          prevRiskSavings = prevPeriodSavings * input.riskPortionRate;
          prevRisklessSavings = prevPeriodSavings * (1 - input.riskPortionRate);

          riskYield =
            (prevPeriodSavings - withdrawal) *
            input.riskPortionRate *
            simulation.riskRate;
          risklessYield =
            (prevPeriodSavings - withdrawal) *
            (1 - input.riskPortionRate) *
            simulation.risklessRate;
          totalYield = riskYield + risklessYield;

          simulationResults[simulationRun][period].prevRiskSavings =
            prevRiskSavings;

          simulationResults[simulationRun][period] = {
            broke: broke,
            prevRiskSavings: prevRiskSavings,
            prevRisklessSavings: prevRisklessSavings,
            prevPeriodSavings: prevPeriodSavings,
            endPeriodSavings: endPeriodSavings,
            riskYield: riskYield,
            risklessYield: risklessYield,
            totalYield: totalYield,
            endPeriodRiskSavings: endPeriodRiskSavings,
            endPeriodRisklessSavings: endPeriodRisklessSavings,
            withdrawal: withdrawal,
            risklessRate: simulation.risklessRate,
            riskRate: simulation.riskRate,
            periodLength: simulation.periodLength
          };

          prevPeriodSavings = endPeriodSavings;
        } else {
          simulationResults[simulationRun][period] = { broke: true };
        }
      });

      return { simulation: simulationResultsLine, broke: broke };
    }
  );


  let brokeProbability =
    simulationResults.filter((y) => y.broke).length / simulationResults.length;

  let nonBrokeResults = simulationResults.filter((y) => !y.broke);

  let endSavings = nonBrokeResults.map((x) => ({
    savings: x.simulation.slice(-1)[0].endPeriodSavings,
    realSavings:
      x.simulation.slice(-1)[0].endPeriodSavings /
      (1 + inflationrate) ** input.years,
  }));

  let brokeResults = simulationResults.filter((y) => y.broke);

  let avgBrokeYear =
    (brokeResults.reduce(
      (p, c) => p + c.simulation.filter((x) => !x.broke).length,
      0
    ) /
      brokeResults.length) *
    input.periodLength;

  const arr = endSavings.map((x) => x.realSavings);

  let histData = [];
  if (arr.length > 0){
  histData = getHistData(endSavings.map((x) => x.realSavings),"Reales Endvermögen");
  }

  return {
    simulationResults: simulationResults,
    brokeProbability: brokeProbability,
    brokeCounter: brokeResults.length,
    avgBrokeYear: Math.round(avgBrokeYear),
    endSavings: {
      avgEndSavingsReal: getMean(arr),
      endSavingsQ5: getQuantile(arr, 0.05),
      endSavingsQ25: getQuantile(arr, 0.25),
      endSavingsQ50:getQuantile(arr, 0.5),
      endSavingsQ75: getQuantile(arr, 0.75),
      endSavingsQ95: getQuantile(arr, 0.95),
      endSavingsNoneBroke: endSavings,
    },
    histData: histData,
  };
}

export { startCalcXPercent };
